//LeaveReports
<template>
  <div>
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000" rounded elevation="2">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text small @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="pa-4 rounded-xl elevation-2">
      <v-tabs v-model="tabs" background-color="brand" dark grow slider-color="yellow" class="rounded-xl no-display">
        <v-tab>
          <v-icon left>mdi mdi-file-edit-outline</v-icon>
          Manual SubjectRemark Entry
        </v-tab>
        <v-tab>
          <v-icon left>mdi mdi-file-import-outline</v-icon>
          Import SubjectRemark (CSV)
        </v-tab>
      </v-tabs>
      

      <v-tabs-items v-model="tabs" >
        <v-tab-item>
          <v-card flat>
            <enter-learner-subject-remark></enter-learner-subject-remark>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat class="pt-1">        
            <import-learner-subject-remark></import-learner-subject-remark>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import EnterLearnerSubjectRemark from "./EnterLearnerSubjectRemark.vue";;
import ImportLearnerSubjectRemark from "./ImportLearnerSubjectRemark.vue";

export default {
     components: {
    EnterLearnerSubjectRemark,
    ImportLearnerSubjectRemark
  },
  data() {
    return {     
      snackbar_msg: "",
      color: "",
      snackbar: false,
      tabs: 0,
    };
  },

  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },

  mounted() {},
};
</script>

<style scoped>
.v-tabs {
  border-radius: 12px;
}

.v-tab {
  font-weight: bold;
  letter-spacing: 0.5px;
}
@media print{
     .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
}
</style>
